import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {

    // region Methods
    transform(value: string, format: string): string {
        const areaCode = value.substring(0, 3);
        const exchange = value.substring(3, 6);
        const lastFour = value.substring(6, 10);
        const formattedPhoneNumber = `${areaCode}-${exchange}-${lastFour}`;
        return formattedPhoneNumber;
    }

    // endregion
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/phone-number.pipe.ts